import { Reveal } from "./Reveal";
import { ClipboardList, CreditCard, CalendarCheck } from "lucide-react";
import { SectionHeading } from "./SectionHeading";

const steps = [
  {
    icon: ClipboardList,
    n: "01",
    title: "Você preenche o formulário",
    desc: "Leva 1 minuto. É onde você diz se quer o programa individual ou para um grupo fechado.",
  },
  {
    icon: CreditCard,
    n: "02",
    title: "Confirma pelo pagamento",
    desc: "Individual: 12× de R$ 596,33 no cartão, por link seguro, ou R$ 6.870 à vista no Pix. Grupo fechado: valor combinado antes.",
  },
  {
    icon: CalendarCheck,
    n: "03",
    title: "Conversa de 20 minutos",
    desc: "A gente define a agenda das 4 sessões e a área que vai para o mapa. Aí é só construir.",
  },
];

export function HowItWorksSection() {
  return (
    <section className="relative bg-charcoal py-12 md:py-16">
      <div className="absolute inset-x-0 top-0 gold-divider" />
      <div className="absolute inset-x-0 bottom-0 gold-divider" />
      <div className="container-narrow">
        <SectionHeading
          eyebrow="Como começa"
          title="Três passos até a primeira sessão."
          subtitle="Sem data de turma para esperar. A agenda é montada com você."
        />

        <div className="mx-auto mt-12 grid max-w-5xl gap-5 md:grid-cols-3">
          {steps.map((s, i) => (
            <Reveal y={20} duration={0.55} delay={i * 0.1}
              key={s.n}
              className="rounded-2xl border border-border/60 bg-card/40 p-7"
            >
              <div className="mb-5 flex items-center gap-4">
                <span className="flex h-11 w-11 items-center justify-center rounded-xl bg-gradient-gold shadow-elegant">
                  <s.icon className="h-5 w-5 text-primary-foreground" />
                </span>
                <span
                  className="text-xs uppercase tracking-[0.3em] text-gold/70"
                  style={{ fontFamily: "var(--font-display)" }}
                >
                  Passo {s.n}
                </span>
              </div>
              <h3 className="mb-2 text-lg text-ivory">{s.title}</h3>
              <p className="text-sm leading-relaxed text-slate-muted">{s.desc}</p>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
